import AffiliateNotificationsToken from '@apps/maha/admin/tokens/affiliate_notifications'
import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Edit from '../edit'
import React from 'react'

const Overview = ({ affiliate }) => {

  const details = {
    audits: `maha_affiliates/${affiliate.id}`,
    comments: `maha_affiliates/${affiliate.id}`,
    sections: [
      {
        title: 't(Affiliate)',
        items: [
          { label: 't(Team)', content: affiliate.team.title },
          { label: 't(Active Referrals)', content: (
            <>{affiliate.active_referrals_count} / {affiliate.referrals_count}</>
          ) },
          ...(affiliate.service === 'paypal' ? [
            { label: 't(Paypal Email)', content: affiliate.service_id }
          ] : affiliate.service === 'venmo' ? [
            { label: 't(Venmo Username)', content: affiliate.service_id }
          ] : []),
          { label: 't(Agreed to Terms)', content: affiliate.agreed_to_terms, format: 'yes_no' },
          { label: 't(Commission Rate)', content: affiliate.rate, format: 'rate' },
          { label: 't(Notifications)', content: <AffiliateNotificationsToken value={ affiliate.notifications } /> }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  affiliate: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview affiliate={ props.affiliate } />,
  tasks: {
    items: [
      {
        label: 't(Edit Affiliate)',
        svg: 'square_pen',
        modal: <Edit affiliate={ props.affiliate } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
